import { TRACER_BY_ID } from '@vm/content';
import { hex } from './format';

/** Preview chip of a bullet tracer style: a little animated streak (CSS only). 'none' shows the weapon's own tracer color. */
export function TracerSwatch(props: { id: string; /** The weapon's own tracer color, shown for the Factory style. */ fallback?: number; big?: boolean }) {
  const def = TRACER_BY_ID[props.id];
  const style = props.id === 'none' || !def ? 'solid' : def.style;
  const c1 = def?.colors[0] ?? props.fallback ?? 0xffe08a;
  const c2 = def?.colors[1] ?? c1;
  return <span class={`tracer-swatch is-${style} ${props.big ? 'big' : ''}`} style={{ '--t1': hex(c1), '--t2': hex(c2) } as Record<string, string>} />;
}
